// PL
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "Nowy check-in",
    manualDispatchTitle: "Ręczne zamknięcie końcowej wysyłki",
    manualDispatchText:
      "Jeśli jeden z gości nie przyjedzie, możesz ręcznie zamknąć ten proces, aby już teraz wysłać posiadaczowi rezerwacji wiadomość powitalną, klucze cyfrowe i dokument.",
    sending: "Wysyłanie...",
    completeManualSend: "Zakończ ręcznie i wyślij",
    finalSendProcessed: "Końcowa wysyłka już zrealizowana",
    arrivalInstructions: "Instrukcje przyjazdu",
    arrivalAlreadySent: "Już wysłane. W razie potrzeby możesz wysłać je gościowi ponownie.",
    arrivalAutoInfo:
      "Są wysyłane automatycznie o zaplanowanej godzinie. Możesz przyspieszyć wysyłkę i wysłać je teraz (wiadomość, dostęp i skonfigurowane pliki).",
    resendNow: "Wyślij ponownie teraz",
    sendNow: "Wyślij teraz",

    titleEditCheckin: "Edytuj check-in",
    titleDeleteCheckin: "Usuń check-in",

    confirmManualTitle: "Zakończyć wysyłkę ręcznie?",
    confirmManualMsg:
      "Użyj tej akcji, gdy nie będzie już kolejnych gości do check-in, a informacje końcowe trzeba wysłać posiadaczowi rezerwacji już teraz.",
    yesSendNow: "Tak, wyślij teraz",
    cancel: "Anuluj",
    manualSendFailed: "Nie udało się zrealizować wysyłki ręcznej.",
    sendProcessedTitle: "Wysyłka zrealizowana",
    finalInfoProcessed: "Końcowe informacje o check-in zostały już przetworzone.",
    couldNotSend: "Nie udało się wysłać",

    confirmResendArrivalTitle: "Wysłać ponownie instrukcje przyjazdu?",
    confirmSendArrivalTitle: "Wysłać instrukcje przyjazdu teraz?",
    confirmResendArrivalMsg:
      "Instrukcje przyjazdu zostały już wysłane. Czy chcesz wysłać je gościowi ponownie teraz?",
    confirmSendArrivalMsg:
      "Instrukcje przyjazdu (wiadomość, dostęp i skonfigurowane pliki) zostaną wysłane gościowi teraz, bez czekania na zaplanowaną godzinę.",
    arrivalSendFailed: "Nie udało się wysłać instrukcji przyjazdu.",
    pendingDeliveryTitle: "Wysyłka oczekuje",
    instructionsSentTitle: "Instrukcje wysłane",
    arrivalSentToGuest: "Instrukcje przyjazdu zostały wysłane gościowi.",

    stepGuestData: "Dane gościa",
    stepSignature: "Podpis",
    stepRegistered: "Check-in zarejestrowany",

    sectionPersonal: "Dane osobowe",
    sectionStay: "Pobyt",
    sectionDocument: "Dokument",

    nombre: "Imię",
    apellido: "Nazwisko",
    sexo: "Płeć",
    select: "Wybierz",
    male: "Mężczyzna",
    female: "Kobieta",
    preferNotToSay: "Wolę nie podawać",
    other: "Inna",
    birthDate: "Data urodzenia",
    minorsTraveling: "Czy w tej rezerwacji podróżują osoby niepełnoletnie?",
    no: "Nie",
    yes: "Tak",
    relationshipMinor: "Pokrewieństwo osoby niepełnoletniej",
    relationshipToMinor: "Pokrewieństwo wobec osoby niepełnoletniej",
    phone: "Telefon",
    email: "E-mail",
    checkInDate: "Data check-in",
    checkOutDate: "Data check-out",

    nationality: "Narodowość",
    cittadinanza: "Cittadinanza / Obywatelstwo",
    documentType: "Rodzaj dokumentu",
    documentNumber: "Numer dokumentu",
    supportNumber: "Numer nośnika dokumentu",
    docTypes: {
      passport: "Paszport",
      identityDoc: "Dokument tożsamości",
      co_cc: "Dowód obywatelski (Cédula de Ciudadanía)",
      co_ce: "Dowód cudzoziemca (Cédula de Extranjería)",
      co_ppt: "Zezwolenie na pobyt tymczasowy (PPT)",
      co_pep: "Specjalne zezwolenie na pobyt (PEP)",
      co_de: "Dokument zagraniczny",
    },
    relationships: {
      co: {
        PADRE: "Ojciec",
        MADRE: "Matka",
        HIJO: "Syn/córka",
        ABUELO: "Dziadek/babcia",
        HERMANO: "Brat/siostra",
        TIO: "Wujek/ciocia",
        TUTOR: "Opiekun prawny",
        OTRO: "Inne",
      },
      es: {
        HJ: "Syn/córka",
        AB: "Dziadek/babcia",
        BA: "Pradziadek/prababcia",
        BN: "Prawnuk/prawnuczka",
        CD: "Szwagier/szwagierka",
        CY: "Małżonek/małżonka",
        HR: "Brat/siostra",
        NI: "Wnuk/wnuczka",
        OT: "Inne",
        PM: "Ojciec/matka",
        SB: "Siostrzeniec/siostrzenica",
        SG: "Teść/teściowa",
        TI: "Wujek/ciocia",
        TU: "Opiekun",
        YN: "Zięć/synowa",
      },
    },

    italyBannerTitle: "Dane wymagane we Włoszech · Alloggiati Web",
    italyBannerText:
      "Polizia di Stato wymaga podania państwa urodzenia, gminy urodzenia oraz miejsca wydania dokumentu.",
    sectionBirthData: "Dane o urodzeniu",
    statoNascita: "Stato di nascita / Państwo urodzenia",
    birthStateHint: "Państwo urodzenia może różnić się od narodowości.",
    comuneNascita: "Gmina urodzenia",
    luogoRilascio: "Miejsce wydania dokumentu",
    luogoRilascioHint: "Włoska gmina lub obce państwo, które wydało dokument.",
    searchCittadinanza: "Szukaj obywatelstwa…",
    searchStatoNascita: "Szukaj państwa urodzenia…",
    searchComuneNascita: "Szukaj gminy urodzenia…",
    searchComuneRilascio: "Gmina wydania…",
    searchStatoRilascio: "Państwo wydania…",

    sectionSes: "Dane SES Hospedajes",
    countryResidence: "Kraj zamieszkania",
    cityResidence: "Miasto zamieszkania",
    address: "Adres",
    zipCode: "Kod pocztowy",
    paymentMethod: "Metoda płatności",
    paymentDate: "Data płatności",
    pay: {
      efectivo: "Gotówka",
      destino: "Płatność na miejscu",
      tarjeta: "Karta",
      movil: "Płatność mobilna",
      plataforma: "Platforma",
      transferencia: "Przelew bankowy",
    },

    sireLegalTitle: "SIRE i TRA: informacja prawna",
    sireLegalText:
      "W przypadku obiektów w Kolumbii żądane informacje są zbierane zgodnie z przepisami Migración Colombia (SIRE) oraz rejestru gości (TRA).",
    sectionSire: "Dane SIRE / TRA",
    searchNationality: "Szukaj narodowości...",
    searchCountry: "Szukaj kraju...",
    noResults: "Brak wyników",
    countryOrigin: "Kraj pochodzenia",
    searchCountryOrigin: "Szukaj kraju pochodzenia...",
    cityOrigin: "Miasto pochodzenia",
    searchCity: "Szukaj miasta...",
    searchMunicipality: "Szukaj gminy...",
    nextDestinationCountry: "Kraj kolejnego celu podróży",
    searchDestinationCountry: "Szukaj kraju docelowego...",
    summaryOrigin: "Pochodzenie",
    summaryDestination: "Cel podróży",

    sectionIdentity: "Weryfikacja tożsamości",
    recommended: "zalecane",
    identityActiveInfo:
      "Ten obiekt ma włączoną weryfikację tożsamości. Prześlij zdjęcia dokumentu gościa.",
    documentFront: "Przód dokumentu",
    uploadPhoto: "Prześlij zdjęcie",
    selfieGuest: "Selfie gościa",
    altDocumentFront: "Przód dokumentu",
    altMinorAuth: "Zgoda dla osoby niepełnoletniej",
    titleRemove: "Usuń",

    sectionMinorDocs: "Dokumentacja osoby niepełnoletniej",
    optional: "opcjonalnie",
    minorInfo: "W przypadku osób niepełnoletnich możesz przesłać zgodę na podróż lub dokument opiekuna.",
    guardianAuthDoc: "Zgoda / dokument opiekuna",
    uploadDocument: "Prześlij dokument",

    sectionSignature: "Podpis gościa",
    signatureHint: "Poproś gościa o podpis w polu, aby zaakceptował regulamin obiektu.",
    undo: "Cofnij",
    clear: "Wyczyść",
    termsAccept: "Gość akceptuje regulamin i warunki obiektu",

    successTitle: "Check-in zarejestrowany!",
    successBefore: "Check-in dla",
    successAfter: "został zapisany pomyślnie.",

    next: "Dalej",
    back: "Wstecz",
    saving: "Zapisywanie...",
    saveCheckin: "Zapisz check-in",
    close: "Zamknij",

    vNombre: "Imię jest wymagane",
    vApellido: "Nazwisko jest wymagane",
    vSexo: "Płeć jest wymagana",
    vBirthDate: "Data urodzenia jest wymagana",
    vPhone: "Telefon jest wymagany",
    vCheckIn: "Data check-in jest wymagana",
    vCheckOut: "Data check-out jest wymagana",
    vNationality: "Narodowość jest wymagana",
    vDocType: "Rodzaj dokumentu jest wymagany",
    vDocNumber: "Numer dokumentu jest wymagany",
    vEmailFormat: "Format adresu e-mail jest nieprawidłowy",
    vDocSupport: "Numer nośnika dokumentu jest wymagany",
    vMinors: "Wskaż, czy w rezerwacji podróżują osoby niepełnoletnie",
    vRelationship: "Pokrewieństwo towarzyszącej osoby niepełnoletniej jest wymagane",
    vCountryResidence: "Kraj zamieszkania jest wymagany",
    vCityResidence: "Miasto zamieszkania jest wymagane",
    vAddress: "Adres jest wymagany",
    vZip: "Kod pocztowy jest wymagany",
    vPaymentMethod: "Metoda płatności jest wymagana",
    vPaymentDate: "Data płatności jest wymagana",
    vCountryOrigin: "Kraj pochodzenia jest wymagany",
    vNextDest: "Kraj kolejnego celu podróży jest wymagany",
    vCityOrigin: "Miasto pochodzenia jest wymagane",
    vStatoNascita: "Państwo urodzenia (Stato di nascita) jest wymagane",
    vComuneNascita: "Gmina urodzenia (Comune di nascita) jest wymagana",
    vLuogoRilascio: "Miejsce wydania dokumentu (Luogo di rilascio) jest wymagane",

    vTerms: "Aby kontynuować, należy zaakceptować regulamin",
    vSignaturePad: "Błąd dostępu do panelu podpisu",
    vSignature: "Podpis jest wymagany",
    saveCheckinError: "Wystąpił błąd podczas zapisywania check-in",
    saveCheckinErrorGeneric: "Błąd zapisu check-in",
    socketCheckinDone: "<strong>{name}</strong> ukończył check-in ręczny",
    identityPhotosError: "Check-in został zapisany, ale nie udało się przesłać zdjęć do weryfikacji tożsamości",
    minorAuthError: "Check-in został zapisany, ale nie udało się przesłać zgody dla osoby niepełnoletniej",

    docDni: "Nieprawidłowy DNI. Musi mieć 8 cyfr i poprawną literę kontrolną (np. 12345678Z)",
    docNie: "Nieprawidłowy NIE. Format: X/Y/Z + 7 cyfr + litera kontrolna (np. X1234567Z)",
    docPassport: "Nieprawidłowy paszport. Musi mieć od 6 do 20 znaków alfanumerycznych",
    docCc: "Nieprawidłowy dowód obywatelski. Musi mieć od 6 do 10 cyfr",
    docCe: "Nieprawidłowy dowód cudzoziemca. Musi mieć od 6 do 12 znaków alfanumerycznych",
    docPptPep: "Nieprawidłowy {tipo}. Musi mieć od 4 do 15 znaków alfanumerycznych",

    zipNotFound: "Nie znaleziono kodu pocztowego. Sprawdź numer i spróbuj ponownie.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    holdLeftMinutes: "zostało {min} min na płatność",
    holdLeftSeconds: "zostało {seg} s na płatność",
    holdExpired: "termin minął: noce zostały zwolnione",
    requestPendingTitle: "Prośba o rezerwację oczekuje",
    requestPendingText:
      "Gość poprosił o te terminy. Kalendarz nie jest zablokowany, dopóki nie zaakceptujesz prośby.",
    approving: "Akceptowanie…",
    approve: "Zaakceptuj",
    rejecting: "Odrzucanie…",
    reject: "Odrzuć",
    requestRejectedTitle: "Prośba odrzucona",
    requestRejectedText: "Ta prośba została odrzucona przez obiekt i nie może już zostać potwierdzona.",
    awaitingPaymentTitle: "Oczekiwanie na płatność gościa",
    awaitingPaymentText:
      "Kalendarz jest tymczasowo zablokowany. Jeśli płatność nie zostanie wykonana, dostępność zwolni się automatycznie.",
    remaining: "pozostało",
    marking: "Oznaczanie...",
    markAsPaid: "Oznacz jako opłaconą",
    expiring: "Wygaszanie...",
    markAsExpired: "Oznacz jako wygasłą",

    extensionPendingTitle: "Przedłużenie pobytu oczekuje",
    extraNights: "{count} dodatkowych nocy",
    newCheckout: "nowy check-out",
    awaitingGuestPayment: "oczekuje na płatność gościa",
    pendingApproval: "oczekuje na akceptację",
    confirming: "Potwierdzanie...",

    observation: "Uwaga",

    pendingCharge: "oczekuje na płatność",
    processing: "Przetwarzanie...",

    clientRequested: "Klient poprosił o:",
    serviceFallback: "Usługa",
    toConsult: "na zapytanie",

    approveRequestTitle: "Zaakceptuj prośbę",
    amountToCharge: "Kwota do pobrania",
    noCharge: "0 = bez opłaty",
    approveHint:
      "Jeśli masz podłączoną bramkę płatniczą, do gościa zostanie wysłany <strong>link do płatności</strong> (WhatsApp + e-mail). Jeśli nie, gość otrzyma informację, że <strong>zapłaci po przyjeździe</strong>.",
    cancel: "Anuluj",
    close: "Zamknij",
    approveAndNotify: "Zaakceptuj i powiadom",

    reservationTotal: "Suma rezerwacji:",
    onRequestPaidSeparately: `pozycje "na zapytanie" opłacane są osobno`,
    fullPayment: "Pełna płatność",
    noBalance: "(bez salda)",
    deposit: "Zaliczka",
    balance: "saldo",
    markPaidHint: `Wybrana kwota zostaje zapisana jako pobrana. "Suma" obejmuje pobyt, sprzątanie i usługi z ceną (np. Uber); pozycje "na zapytanie" mają własną opłatę.`,
    confirm: "Potwierdź",

    paymentExpiredTitle: "Czas na płatność minął",
    paymentExpiredText: "Rezerwacja tymczasowa wygasła, a dostępność została zwolniona automatycznie.",

    overbookingTitle: "Rezerwacja w overbookingu",
    overbookingText:
      "Jej terminy kolidują z inną rezerwacją tego obiektu. Terminy pozostają zablokowane w OTA. Jeśli konflikt został już rozwiązany (druga rezerwacja anulowana lub przeniesiona), potwierdź to tutaj.",
    verifying: "Weryfikowanie...",
    confirmReservation: "Potwierdź rezerwację",

    checkinInvitation: "Zaproszenie do check-in",
    copyCheckinLink: "Kopiuj link do check-in",
    editReservation: "Edytuj rezerwację",

    codesAndAccess: "Kody i dostęp",
    codesAndAccessSub: "Klucze i linki dostępu dla gościa",
    currentAccessCodes: "Aktualne kody dostępu:",
    currentAccessCode: "Aktualny kod dostępu:",
    guestDigitalAccess: "Cyfrowy dostęp gościa",
    copyOpenLink: "Kopiuj link otwierający",
    copy: "Kopiuj",
    openLink: "Otwórz link otwierający",
    open: "Otwórz",
    yacanNote: "Dostępem dla tej rezerwacji zarządza automatycznie <b>YACAN</b> wraz ze swoimi zamkami.",
    digitalKeyEkey: "Klucz cyfrowy (ekey)",
    openDigitalKey: "Otwórz klucz cyfrowy",
    previousCodesExpired: "Poprzednie kody (już wygasłe):",
    sentOn: "wysłano",
    generated: "wygenerowano",
    expiredOn: "wygasł",

    amountAndPayment: "Kwota i płatność",
    amountAndPaymentSub: "Rozbicie, status pobrania i fakturowanie",

    guestJourney: "Ścieżka gościa",
    eventsCount: "{count} zdarzenie | {count} zdarzenia | {count} zdarzeń",
    journeySubtitle: "Pełna historia od rezerwacji do check-out",
    stagesCompleted: "ukończonych etapów",
    nextLabel: "Dalej:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Co jeszcze zostało",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Zgłoszenie gości",
    authoritiesAction: "zostało zgłoszone służbom",
    authoritiesDesc: "Wysłano do {services}",
    viewInChat: "Zobacz w czacie",

    accessCode: "Kod dostępu",
    accessCodeSub: "Edytuj i wyślij klucz gościowi",
    currentlyConfiguredCode: "Obecnie skonfigurowany kod",
    newCode: "Nowy kod",
    keepSameToResend: "zostaw taki sam, aby wysłać ponownie bez zmian",
    placeholderCode: "Np. ABCD1234",
    codeSavedUppercaseHint: "Kod zostanie zapisany wielkimi literami i wysłany przez WhatsApp lub e-mail.",
    sending: "Wysyłanie...",
    saveAndSendToGuest: "Zapisz i wyślij gościowi",

    resendAccess: "Wyślij dostęp ponownie",
    sendAccess: "Wyślij dostęp",
    resendPin: "Wyślij PIN ponownie",
    sendPin: "Wyślij PIN",
    activating: "Aktywowanie...",
    resendCode: "Wyślij kod ponownie",
    sendAccessCode: "Wyślij kod dostępu",

    channelManager: "channel manager",
    directBooking: "rezerwacja bezpośrednia",
    directTag: "Bezpośrednia",
    bookingRegistered: "Rezerwacja zarejestrowana",
    bookedViaOta: "zarezerwował przez OTA",
    createdBooking: "utworzył rezerwację",
    incomingVia: "Przychodzi przez {channel}",
    confirmedTag: "Potwierdzona",
    pendingTag: "Oczekuje",
    bookingConfirmed: "Rezerwacja potwierdzona",
    pendingConfirmation: "Oczekuje na potwierdzenie",
    receivedConfirmation: "otrzymał potwierdzenie rezerwacji",
    awaitingConfirmationAction: "oczekuje na potwierdzenie",
    propertyConfirmed: "Obiekt potwierdził rezerwację",
    awaitingConfirmationDesc: "Oczekiwanie na potwierdzenie",
    sentTag: "Wysłane",
    notSentTag: "Niewysłane",
    checkinInvitationTitle: "Zaproszenie do check-in",
    receivedCheckinInvite: "otrzymał zaproszenie do check-in",
    notReceivedCheckinInvite: "nie otrzymał jeszcze zaproszenia do check-in",
    checkinLinkSent: "Link do check-in wysłany gościowi",
    inviteNotSentYet: "Zaproszenie nie zostało jeszcze wysłane",
    completedTag: "Ukończone",
    checkinOnline: "Check-in online",
    didCheckinOnline: "ukończył check-in online",
    notYetCheckinOnline: "nie ukończył jeszcze check-in online",
    guestsRegistered: "Zarejestrowani goście: {count}",
    guestNotCompletedCheckin: "Gość nie ukończył jeszcze check-in",
    sentTagPlural: "Wysłane",
    accessCodes: "Kody dostępu",
    receivedAccessCodes: "otrzymał kody dostępu",
    notReceivedAccessCodes: "nie otrzymał jeszcze kodów dostępu",
    accessKeysSent: "Klucze dostępu wysłane gościowi",
    pendingSendAccess: "Oczekuje na wysłanie dostępu",
    finishedTag: "Zakończony",
    plannedTag: "Zaplanowany",
    guestCheckout: "Check-out gościa",
    finishedStay: "zakończył swój pobyt",
    plannedCheckout: "ma zaplanowany check-out",
    stayFinished: "Pobyt się zakończył",
    autoCheckoutScheduled: "Zaplanowany automatyczny check-out",
    theGuest: "Gość",
    theTeam: "Zespół",
    theChannel: "Kanał",
    theSystem: "System",
    calledFromNumber: "zadzwonił z numeru {phone}",

    filterAll: "Wszystko",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Połączenia",
    filterCheckin: "Check-in",
    filterAccess: "Dostęp",
    filterBooking: "Rezerwacja",

    error: "Błąd",
    requestApprovedMsg: "Prośba zaakceptowana. Rezerwacja jest potwierdzona.",
    requestApprovedTitle: "✓ Zaakceptowana",
    couldNotApprove: "Nie udało się zaakceptować.",
    confirmRejectRequestMsg: "Czy na pewno chcesz odrzucić tę prośbę? Nie można tego cofnąć.",
    rejectRequestHeader: "Odrzuć prośbę",
    yesReject: "Tak, odrzuć",
    requestRejectedMsg: "Prośba odrzucona.",
    rejectedTitle: "Odrzucona",
    couldNotReject: "Nie udało się odrzucić.",
    couldNotLoadOptions: "Nie udało się wczytać opcji; zostanie oznaczona pełna kwota.",
    noticeTitle: "Uwaga",
    depositMarkedPaid: "Zaliczka oznaczona jako opłacona. Rezerwacja potwierdzona z pozostałym saldem.",
    fullMarkedPaid: "Rezerwacja oznaczona jako opłacona w całości i potwierdzona.",
    paymentConfirmedTitle: "Płatność potwierdzona",
    couldNotMarkPaid: "Nie udało się oznaczyć jako opłaconej.",
    tempReservationExpired: "Rezerwacja tymczasowa została wygaszona, a dostępność zwolniona.",
    reservationExpiredTitle: "Rezerwacja wygasła",
    couldNotMarkExpired: "Nie udało się oznaczyć jako wygasłej.",
    extensionMarkedPaid: "Przedłużenie zostało oznaczone jako opłacone i potwierdzone.",
    extensionConfirmedTitle: "Przedłużenie potwierdzone",
    couldNotConfirmExtension: "Nie udało się potwierdzić przedłużenia.",
    extensionCancelled: "Przedłużenie zostało anulowane, a dostępność zwolniona.",
    extensionRejectedTitle: "Przedłużenie odrzucone",
    couldNotRejectExtension: "Nie udało się odrzucić przedłużenia.",
    chargeMarkedPaid: "Opłata została oznaczona jako zapłacona.",
    chargeRegisteredTitle: "Płatność zapisana",
    couldNotMarkChargePaid: "Nie udało się oznaczyć opłaty jako zapłaconej.",
    chargeRejected: "Opłata została odrzucona i usunięta z rezerwacji.",
    chargeRejectedTitle: "Opłata odrzucona",
    couldNotRejectCharge: "Nie udało się odrzucić opłaty.",
    approvedState: "Zaakceptowana",
    rejectedState: "Odrzucona",
    paidState: "Opłacona",
    pendingYourResponse: "Oczekuje na Twoją odpowiedź",
    enterValidAmount: "Podaj prawidłową kwotę (0 = bez opłaty).",
    amountTitle: "Kwota",
    approvedPaymentLinkSent: "Zaakceptowano. Link do płatności został wysłany gościowi (WhatsApp + e-mail).",
    serviceApprovedTitle: "Usługa zaakceptowana",
    approvedPayOnArrival: "Zaakceptowano. Gość zapłaci po przyjeździe (brak podłączonej bramki).",
    approvedGuestNotified: "Zaakceptowano. Gość został powiadomiony.",
    couldNotApproveRequest: "Nie udało się zaakceptować prośby.",
    requestRejectedNotified: "Prośba odrzucona. Gość został powiadomiony.",
    serviceRejectedTitle: "Usługa odrzucona",
    couldNotRejectRequest: "Nie udało się odrzucić prośby.",
    resendAccessLinkMsg: "Czy chcesz wysłać link dostępu ponownie dostępnymi kanałami?",
    sendAccessLinkMsg: "Czy chcesz wysłać link dostępu dostępnymi kanałami?",
    resendPinMsg:
      "Czy chcesz wysłać kod dostępu ponownie dostępnymi kanałami? Zostanie wygenerowany nowy PIN.",
    sendPinMsg: "Czy chcesz wygenerować i wysłać kod dostępu dostępnymi kanałami?",
    sendDigitalAccessHeader: "Wyślij dostęp cyfrowy",
    sendPinHeader: "Wyślij PIN dostępu",
    send: "Wyślij",
    accessLinkSent: "Link dostępu wysłany gościowi",
    accessSentTitle: "Dostęp wysłany",
    successSummary: "Sukces",
    digitalAccessSentDetail: "Dostęp cyfrowy został wysłany dla {count} urządzeń",
    ttlockCodesGenerated: "Dla rezerwacji wygenerowano i przetworzono kody TTLock w liczbie {count}.",
    accessCodeResent: "Kod dostępu wysłany ponownie: {code}",
    accessCodeGeneratedSent: "Kod dostępu wygenerowany i wysłany: {code}",
    pinSentTitle: "PIN wysłany",
    pinProcessedDetail: "PIN został przetworzony dla {count} zamków",
    pinProcessedBlebox: "oraz dla {count} drzwi elektronicznych",
    couldNotSendAccessCode: "Nie udało się wysłać kodu dostępu",
    codeCopied: "Kod skopiowany do schowka",
    mainGate: "Brama główna",
    accommodation: "Obiekt",
    doorLabel: "Drzwi obiektu",
    validUntil: "Ważny do: {date}",
    earlyAccessLinkMsg:
      "Spowoduje to natychmiastową aktywację linku dostępu (przed zwykłą godziną check-in).",
    earlyAccessPinMsg: "Spowoduje to natychmiastową aktywację PIN-u (przed zwykłą godziną check-in).",
    earlyAccessHeader: "Wcześniejszy dostęp",
    activate: "Aktywuj",
    earlyAccessActivated: "Wcześniejszy dostęp aktywowany",
    okSummary: "OK",
    earlyAccessActivatedDetail: "Wcześniejszy dostęp został aktywowany",
    couldNotActivateEarlyAccess: "Nie udało się aktywować wcześniejszego dostępu",
    cancelReservationMsg:
      "Rezerwacja zostanie anulowana w całości. Jeśli zajmuje kilka pokoi (nawet różnych typów), wszystkie zostaną anulowane i zwolnione. Tej operacji nie można cofnąć.",
    goBack: "Wstecz",
    resolveOverbookingMsg:
      "Sprawdzimy, czy nie ma już konfliktu z inną rezerwacją. Jeśli terminy są wolne, rezerwacja zostanie potwierdzona, a jej terminy pozostaną zablokowane w OTA.",
    confirmOverbookingHeader: "Potwierdź rezerwację w overbookingu",
    reservationConfirmed: "Rezerwacja potwierdzona.",
    couldNotConfirmReservation: "Nie udało się potwierdzić rezerwacji.",
    reservationCancelledFreed: "Rezerwacja anulowana. Zwolniono pokoje w liczbie {count}.",
    otaLangPrompt:
      "Ta rezerwacja z OTA nie ma numeru telefonu. Wskaż język wiadomości, aby wysłać check-in przez czat OTA: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Zaproszenie przetworzone. Wysłano je także e-mailem i czatem OTA.",
    inviteProcessedOta: "Zaproszenie przetworzone. Wysłano je także czatem OTA.",
    inviteProcessedEmail: "Zaproszenie przetworzone. Wysłano je także e-mailem.",
    couldNotSendCheckinInvite: "Nie udało się wysłać zaproszenia do check-in",
    couldNotLoadConversations: "Nie udało się wczytać rozmów",
    reservationUpdatedShort: "Rezerwacja zaktualizowana",
    couldNotUpdateReservation: "Nie udało się zaktualizować rezerwacji",
    codeEmpty: "Kod nie może być pusty",
    attentionTitle: "Uwaga",
    accessCodeProcessed: "Kod dostępu przetworzony pomyślnie",
    sentCheckTitle: "Wysłane ✓",
    accessCodeSendProcessed: "Wysyłka kodu dostępu została przetworzona.",
    couldNotSendCode: "Nie udało się wysłać kodu",
    chatOta: "czat OTA",
    emailChannel: "e-mail",
    channelsUsed: "Użyte kanały: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "Ten numer nie wygląda na prawidłowy dla {pais}. Jeśli gość jest z innego kraju, zmień flagę. Kliknij zapisz ponownie, aby mimo to go zachować.",
  },
  hotelResModal: {
    otaBanner:
      "Rezerwacja z OTA: w WA Checkin nie można zmienić <strong>terminów</strong>, <strong>typu</strong> ani <strong>liczby pokoi</strong>. Trzeba to zrobić w OTA (Booking, Airbnb itp.).",
    otaLock: "Rezerwacja z OTA: terminy, typ i liczbę można zmienić tylko w OTA.",
    close: "Zamknij",
    placeholderEmail: "email@example.com",
    roomAbbr: "Pokój",
    fromCalendar: "z kalendarza",
    noMatches: "Brak wyników",
    undo: "Cofnij",
    removeRoom: "Usuń pokój",
    willBeRemovedOnSave: "Zostanie usunięty przy zapisaniu zmian.",
    checkingAvailability: "Sprawdzanie dostępności…",
    availableCount: "{count} dostępny | {count} dostępne | {count} dostępnych",
    notEnoughAvail: "Niewystarczająca dostępność",
    freeCount: "{count} wolny | {count} wolne | {count} wolnych",
    total: "razem",
    nightsCount: "{count} noc | {count} noce | {count} nocy",
    resendConfirmationTitle: "Wyślij ponownie wiadomość z potwierdzeniem",
    resendConfirmationSub: "Ponownie wysyła gościowi szablon potwierdzenia.",
    resendConfirmationNote:
      "Po zmodyfikowaniu rezerwacji <strong>szablon potwierdzenia</strong> zostanie wysłany ponownie dla tej rezerwacji.",
    room: "Pokój",

    noEnoughUnitsFree: "Niewystarczająca dostępność. Wolne jednostki: {units}.",
    closedPeriodManual: "Wybrany zakres obejmuje dni zamknięte przez właściciela.",
    noAvailForDates: "Brak dostępności w tych terminach.",
    selectRoomType: "Wybierz typ pokoju.",
    selectValidDates: "Wybierz prawidłowe terminy.",
    enterGuestName: "Podaj nazwisko gościa.",
    invalidEmail: "Adres e-mail jest nieprawidłowy.",
    enterValidPhone: "Podaj prawidłowy numer telefonu.",
    noAvailCreateModify: "Brak dostępności, aby utworzyć lub zmienić rezerwację w tych terminach.",
    aRoom: "pokój",
    notEnoughAvailIn: "Niewystarczająca dostępność w: {names}.",
    missingOnCreate: "W komponencie nadrzędnym brakuje onCreateReservation.",
    aRoomType: "typ pokoju",
    notEnoughAvailInType: `Niewystarczająca dostępność w "{name}".`,
    sameHotelOnly: "Rezerwacja nie może łączyć pokoi z dwóch hoteli. Usuń te, które nie są z tego hotelu.",
    otherHotelLinesDropped: "Pokoje z poprzedniego hotelu zostały usunięte: rezerwacja dotyczy jednego hotelu.",
    partiallyCreated: "Utworzono {ok} z {total} pokoi, a kolejny się nie powiódł. Sprawdź rezerwację przed ponowną próbą.",
    reservationIdNotFound: "Nie znaleziono identyfikatora rezerwacji.",
    cannotRemoveAll: "Nie można usunąć wszystkich pokoi. Aby to zrobić, anuluj całą rezerwację.",
    thisRoom: "ten pokój",
    confirmRemoval:
      "Zamierzasz USUNĄĆ z rezerwacji: {names}. Te pokoje zostaną zwolnione i przestaną być rozliczane. Kontynuować i zapisać?",
    couldNotUpdate: `Nie udało się zaktualizować "{name}".`,
    couldNotRemove: `Nie udało się usunąć "{name}".`,
    couldNotRemovePrimary: "Nie udało się usunąć głównego pokoju.",
    reservationUpdated: "Rezerwacja zaktualizowana pomyślnie",
    updatedPartially: "Zapisano tylko część: sprawdź pokoje w tej rezerwacji.",
    couldNotUpdateReservation: "Nie udało się zaktualizować rezerwacji.",
  },
};
